"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hostsReducer = exports.initialHostsState = void 0;
const types_1 = require("./types");
exports.initialHostsState = {
    ws: '',
    thumbs: '',
    avatars: '',
    backoffice: '',
    frontend: '',
    serverDown: false,
};
function hostsReducer(state = exports.initialHostsState, action) {
    switch (action.type) {
        case types_1.SET_HOSTS: {
            return { ...action.hosts, serverDown: false };
        }
        case types_1.SET_SERVER_DOWN: {
            return { ...state, serverDown: action.isDown };
        }
        default: {
            return state;
        }
    }
}
exports.hostsReducer = hostsReducer;
